import { FC } from 'react'
import { OpportunityCategoryId } from 'interfaces/meta'
import { createSelector } from 'reselect'
import { opportunityCountersSelector } from 'selectors/oppertunitiesSelectors'
import { connectLoadable } from 'helpers/loadableHelpers'
import { GuardsParam } from 'interfaces/guards'
import { MapDispatchToPropsFunction } from 'react-redux'
import { setFilterCategoryActionCreator } from 'actions/globalActions'
import { OPPORTUNITIES_PAGE } from 'constants/pages'
import { OPPORTUNITIES_PAGE_PLACEMENT } from 'constants/opportunities'
import RateTabs, { RateTabsDispatchProps, RateTabsOwnProps, RateTabsStateProps } from 'components/features/pfm/RateTabs/RateTabs'
import { OpportunityPlacement } from 'interfaces/opportunities'
import { socialInsightsGuard } from 'guards/socialInsightGuards'

type RateTabsContainerOwnProps = {
  placement: OpportunityPlacement
}

const mapStateToProps = createSelector(
  opportunityCountersSelector,
  (opportunityCounters): RateTabsStateProps => ({
    opportunityCounters,
  }),
)

const mapDispatchToProps: MapDispatchToPropsFunction<RateTabsDispatchProps> = (dispatch) => ({
  onSeeOpportunitiesClick: (categoryId: OpportunityCategoryId) =>
    dispatch(setFilterCategoryActionCreator(OPPORTUNITIES_PAGE, categoryId)),
})

const createRateTabsGuards: GuardsParam = () => [
  socialInsightsGuard,
]

const RateTabsLoader = connectLoadable<
  RateTabsStateProps,
  RateTabsDispatchProps,
  RateTabsOwnProps,
  RateTabsContainerOwnProps
>(createRateTabsGuards, RateTabs)(mapStateToProps, mapDispatchToProps)(RateTabs)


const RateTabsContainer: FC<RateTabsOwnProps> = (props) => (
  <RateTabsLoader placement={ OPPORTUNITIES_PAGE_PLACEMENT } { ...props } />
)

export default RateTabsContainer
